import { FlowType } from "../../constants/FlowType";
import BackgroundInformationForm from "../shared/BackgroundInformation/BackgroundInformationForm";
import { getProducerFlowVerticalStepperElements } from "../../constants/ProducerFlowVerticalStepperElementsFactory";
import { useContext } from "react";
import { GeaoContext } from "../../GeaoContextProvider";
import { ClientConfigurationContext } from "../../../../context/ClientConfigurationContextProvider";

export default function ProducerBackgroundInformation() {
    const { agentInterview } = useContext(GeaoContext);
    const clientConfiguration = useContext(ClientConfigurationContext);

    // Get the dynamic vertical stepper with offshore settings
    const enableOffshore = clientConfiguration?.enableOffshore === true;
    const isOffshoreResident = agentInterview?.questionAnswers?.OffshoreResident?.answer === "true";
    const verticalStepperElements = getProducerFlowVerticalStepperElements(enableOffshore, isOffshoreResident);

    return (
        <BackgroundInformationForm
            verticalStepperElements={verticalStepperElements}
            flowType={FlowType.Producer}
            componentName="ProducerBackgroundInformation"
        />
    );
}
